<script>
  import { fade } from "svelte/transition";
  import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
  import { transitionState } from "$stores";
  import { page } from "$app/stores";
  import { onMount } from "svelte";

  export let pathname = "";

  const pageTransitionDuration = 350;

  let activeRoute = pathname;

  onMount(() => {
    // Handle hash refs when initially loading a page
    if ($page.url.hash) {
      let count = 0;
      const interval = setInterval(() => {
        count++;
        try {
          const elem = document.querySelector($page.url.hash);

          if (count > 50 || elem) {
            clearInterval(interval);

            // Wait a bit for the page to finish rendering before trying to scroll
            setTimeout(() => {
              elem?.scrollIntoView({ behavior: "smooth" });
            }, 1000);
          }
        } catch {
          clearInterval(interval);
        }
      }, 100);
    }
  });
</script>

{#key pathname}
  <div
    in:fade={{
      duration: pageTransitionDuration,
      delay: pageTransitionDuration,
    }}
    out:fade={{ duration: pageTransitionDuration }}
    on:outrostart={() => {
      $transitionState = "in";
    }}
    on:outroend={() => {
      if (!$page.url.search.includes("?ns=true")) {
        window.scrollTo(0, 0);
      }
    }}
    on:introend={() => {
      activeRoute = pathname;
      $transitionState = "out";
      ScrollTrigger.refresh();

      // Handle hash refs when navigating within the site
      if ($page.url.hash) {
        const elem = document.querySelector($page.url.hash);
        elem?.scrollIntoView({ behavior: "smooth" });
      }
    }}
    class:active={pathname !== activeRoute}
  >
    <slot />
  </div>
{/key}
